export default __webpack_public_path__ + "static/media/group-5-logo.b85f7c8c.svg";